/* EYELINER MEDIA — announcement bar infinite-scroll marquee
   Transforms Symmetry's rotating announcement bar into a seamless
   continuous marquee. Self-contained; loaded via doc-head-core.liquid.
   SELF-UPDATING MONTH: at render time it replaces the [MONTH] token
   (and any legacy "<Month> SALE" phrase) with the current calendar
   month, so monthly sale copy never goes stale. */
(function () {
  var SEP = "✳"; /* ✳ */
  var SPEED = 70;     /* px per second */
  var MONTHS = ["January","February","March","April","May","June","July","August","September","October","November","December"];
  var cont, texts;

  function currentMonth() {
    try { return new Date().toLocaleString("en-US", { month: "long" }); }
    catch (e) { return MONTHS[new Date().getMonth()]; }
  }

  /* Swap [MONTH] tokens and "<Month> SALE" patterns for the current month.
     The word-boundary + "SALE" guard avoids rewriting unrelated words
     (e.g. the verb "may"); [MONTH] handles the general case explicitly.
     ({{ }} can't be used here — Shopify treats it as Liquid in theme files.) */
  function applyMonth(html) {
    var mo = currentMonth();
    html = html.replace(/\[\s*MONTH\s*\]/gi, mo);
    html = html.replace(/\b(January|February|March|April|May|June|July|August|September|October|November|December)(\s+SALE)\b/gi, mo + "$2");
    return html;
  }

  function collect() {
    cont = document.querySelector(".announcement-bar__announcements");
    if (!cont) return false;
    texts = [].slice.call(cont.querySelectorAll(".announcement__text"))
      .map(function (el) { return applyMonth(el.innerHTML.trim()); })
      .filter(Boolean);
    return texts.length > 0;
  }

  function injectStyle() {
    if (document.getElementById("em-marquee-style")) return;
    var st = document.createElement("style");
    st.id = "em-marquee-style";
    st.textContent =
      ".em-marquee{overflow:hidden;width:100%;display:block}" +
      ".em-marquee__track{display:flex;flex-wrap:nowrap;white-space:nowrap;width:max-content;will-change:transform;animation:em-marquee-scroll linear infinite}" +
      ".em-marquee__group{display:flex;flex-wrap:nowrap;flex:0 0 auto}" +
      ".em-marquee__item{flex:0 0 auto;padding:0 1.1em;font-family:'Space Mono',ui-monospace,monospace;text-transform:uppercase;letter-spacing:.18em;font-weight:700;font-size:12px;line-height:1;display:inline-flex;align-items:center}" +
      ".em-marquee__item a{color:inherit;text-decoration:underline}" +
      ".em-marquee__sep{flex:0 0 auto;opacity:.55;display:inline-flex;align-items:center;font-size:11px}" +
      "@keyframes em-marquee-scroll{from{transform:translateX(0)}to{transform:translateX(-50%)}}" +
      ".em-marquee:hover .em-marquee__track{animation-play-state:paused}" +
      "@media (prefers-reduced-motion:reduce){.em-marquee__track{animation:none;transform:none}}" +
      ".announcement-bar__left{flex:0 0 auto !important}" +
      ".announcement-bar__right{flex:0 0 auto !important}" +
      ".announcement-bar__middle{flex:1 1 0% !important;min-width:0 !important;max-width:none !important}" +
      ".announcement-bar__announcements{width:100% !important;max-width:none !important;min-width:0 !important}";
    document.head.appendChild(st);
  }

  function item(html) { var s = document.createElement("span"); s.className = "em-marquee__item"; s.innerHTML = html; return s; }
  function sep() { var s = document.createElement("span"); s.className = "em-marquee__sep"; s.setAttribute("aria-hidden", "true"); s.textContent = SEP; return s; }

  function build() {
    if (!cont) return;
    var barWidth = cont.clientWidth || window.innerWidth || 1000;
    var marquee = document.createElement("div"); marquee.className = "em-marquee";
    var track = document.createElement("div"); track.className = "em-marquee__track";
    marquee.appendChild(track);
    cont.innerHTML = ""; cont.appendChild(marquee);

    var group = document.createElement("div"); group.className = "em-marquee__group";
    track.appendChild(group);
    var target = Math.max(barWidth, 320) * 1.2, guard = 0;
    while (group.getBoundingClientRect().width < target && guard < 80) {
      texts.forEach(function (t) { group.appendChild(item(t)); group.appendChild(sep()); });
      guard++;
    }
    var groupWidth = group.getBoundingClientRect().width;
    track.appendChild(group.cloneNode(true)); /* second identical group -> seamless wrap at -50% */
    track.style.animationDuration = Math.max(10, groupWidth / SPEED).toFixed(1) + "s";
  }

  var rt;
  function onResize() { clearTimeout(rt); rt = setTimeout(build, 250); }

  function init() {
    if (!collect()) return;
    injectStyle(); build();
    window.addEventListener("resize", onResize);
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
})();
